import React, { CSSProperties, ReactNode } from 'react';
import { ButtonBase, useColorMode } from '@tonic-ui/react';

type IconButtonProps = { children: ReactNode } & CSSProperties;

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  const [colorMode] = useColorMode();
  const color = {
    dark: 'white:secondary',
    light: 'black:secondary',
  }[colorMode];
  const hoverColor = {
    dark: 'white:emphasis',
    light: 'black:emphasis',
  }[colorMode];
  const activeColor = color;
  const focusColor = color;
  const focusHoverColor = hoverColor;
  const focusActiveColor = activeColor;

  return (
    <ButtonBase
      ref={ref}
      border={1}
      borderColor="transparent"
      color={color}
      transition="all .2s"
      lineHeight={1}
      _hover={{
        color: hoverColor,
      }}
      _active={{
        color: activeColor,
      }}
      _focus={{
        color: focusColor,
      }}
      _focusHover={{
        color: focusHoverColor,
      }}
      _focusActive={{
        color: focusActiveColor,
      }}
      {...props}
    />
  );
});

export default IconButton;
